import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';
// import {COLORS} from '@constants';
import { ThemeSet } from 'src/@setting';

// Inspired by the former Facebook spinners.
function FacebookCircularProgress(props) {
  return (
		<Box
			sx={{
				position: "relative",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				height: "100%",
			}}>
			<CircularProgress
				variant="determinate"
				sx={{
					color: (theme) =>
						theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
				}}
				size={40}
				thickness={6}
				{...props}
				value={100}
			/>
			<CircularProgress
				variant="indeterminate"
				disableShrink
				sx={{
					color: ThemeSet.primary,
					animationDuration: "550ms",
					position: "absolute",
					left: 0,
					[`& .${circularProgressClasses.circle}`]: {
						strokeLinecap: "round",
					},
				}}
				size={40}
				thickness={6}
				{...props}
			/>
		</Box>
	);
}

export default function CustomizedProgressBars() {
  return (
    <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
      <FacebookCircularProgress />
    </Box>
  );
}